import { Amplify } from 'aws-amplify';

// Configure AWS Amplify with environment variables - absolute minimal config
const awsConfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_WiXJ5iTOR',
  aws_user_pools_web_client_id: '2qce2n1f57hnmqphvn850e79aq',
  oauth: {},
  aws_cognito_identity_pool_id: 'default-identity-pool-id'
};

// Debug: Log configuration values
console.log('AWS Configuration:', {
  region: 'us-east-1',
  userPoolId: 'us-east-1_WiXJ5iTOR',
  userPoolWebClientId: '2qce2n1f57hnmqphvn850e79aq',
  cognitoDomain: 'bloomaroot.auth.us-east-1.amazoncognito.com',
  identityPoolId: 'default-identity-pool-id'
});

// Configure Amplify with minimal config - empty oauth to prevent errors
try {
  Amplify.configure(awsConfig);
  console.log('Amplify configured successfully');
} catch (error) {
  console.error('Amplify configuration error:', error);
  // Fallback: try without any oauth config
  try {
    const fallbackConfig = {
      aws_project_region: 'us-east-1',
      aws_cognito_region: 'us-east-1',
      aws_user_pools_id: 'us-east-1_WiXJ5iTOR',
      aws_user_pools_web_client_id: '2qce2n1f57hnmqphvn850e79aq',
      oauth: {},
      aws_cognito_identity_pool_id: 'default-identity-pool-id'
    };
    Amplify.configure(fallbackConfig);
    console.log('Amplify configured with fallback');
  } catch (fallbackError) {
    console.error('Fallback configuration also failed:', fallbackError);
  }
}

export const amplifyConfig = awsConfig;
